import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps3/kafa'
});
export default {
	getCaptcha() {
		return httpClient.get('/api');
	},
	sendData(params) {
		return httpClient.post('/api/pos-invoice', params);
	}
};
